import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import DrawerTablet from "../components/DrawerTablet";
import PortalDrawer from "../components/PortalDrawer";
import AccountForm from "../components/AccountForm";
import Secondary from "../components/Secondary";
import Footer from "../components/Footer";

const MyAccount = () => {
  const navigate = useNavigate();
  const [isDrawerTabletOpen, setDrawerTabletOpen] = useState(false);
  const [isDrawerTablet1Open, setDrawerTablet1Open] = useState(false);

  const onAddButtonContainerClick = useCallback(() => {
    navigate("/sign-up");
  }, [navigate]);

  const openDrawerTablet = useCallback(() => {
    setDrawerTabletOpen(true);
  }, []);

  const closeDrawerTablet = useCallback(() => {
    setDrawerTabletOpen(false);
  }, []);

  const onAddContainerClick = useCallback(() => {
    navigate("/sign-up");
  }, [navigate]);

  const openDrawerTablet1 = useCallback(() => {
    setDrawerTablet1Open(true);
  }, []);

  const closeDrawerTablet1 = useCallback(() => {
    setDrawerTablet1Open(false);
  }, []);

  return (
    <>
      <div className="relative bg-sky-blue-100 w-full overflow-hidden flex flex-col items-center justify-start">
        <div className="self-stretch bg-light flex flex-row p-8 items-center justify-between md:hidden">
          <img className="relative w-[160.68px] h-10" alt="" src="/union.svg" />
          <div className="flex flex-row items-center justify-start gap-[16px]">
            <img
              className="relative w-[21.5px] h-[21.5px] hidden"
              alt=""
              src="/search9.svg"
            />
            <div
              className="rounded-19xl bg-gold flex flex-row items-center justify-start cursor-pointer hover:bg-goldenrod-100"
              onClick={onAddButtonContainerClick}
            >
              <img className="relative w-10 h-10" alt="" src="/add5.svg" />
            </div>
            <div
              className="flex flex-row items-center justify-start cursor-pointer"
              onClick={openDrawerTablet}
            >
              <div className="rounded-19xl bg-sky-blue-100 flex flex-row items-center justify-start hover:bg-aliceblue-200">
                <img
                  className="relative w-[62px] h-[62px]"
                  alt=""
                  src="/add4.svg"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="self-stretch bg-light hidden flex-row p-8 items-center justify-between md:flex md:self-stretch md:w-auto">
          <img className="relative w-[160.68px] h-10" alt="" src="/union.svg" />
          <div className="flex flex-row items-center justify-start gap-[16px]">
            <img
              className="relative w-[21.5px] h-[21.5px] hidden"
              alt=""
              src="/search10.svg"
            />
            <div
              className="rounded-19xl bg-gold flex flex-row items-center justify-start cursor-pointer hover:bg-goldenrod-100"
              onClick={onAddContainerClick}
            >
              <img className="relative w-10 h-10" alt="" src="/add5.svg" />
            </div>
            <div className="flex flex-row items-center justify-start">
              <div
                className="rounded-19xl bg-sky-blue-100 flex flex-row items-center justify-start cursor-pointer hover:bg-goldenrod-100 md:hover:bg-aliceblue-200"
                onClick={openDrawerTablet1}
              >
                <img
                  className="relative w-[62px] h-[62px]"
                  alt=""
                  src="/add4.svg"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="self-stretch bg-sky-blue-100 [backdrop-filter:blur(24px)] flex flex-col py-16 px-8 items-center justify-start gap-[32px] lg:items-center lg:justify-start md:flex-col md:items-center md:justify-start sm:pl-4 sm:pr-4 sm:box-border">
          <AccountForm />
          <Secondary buttonText="Sign Out" secondaryPosition="unset" />
        </div>
        <Footer logo="/union3.svg" />
      </div>
      {isDrawerTabletOpen && (
        <PortalDrawer
          overlayColor="rgba(229, 219, 255, 0.7)"
          placement="Right"
          onOutsideClick={closeDrawerTablet}
        >
          <DrawerTablet onClose={closeDrawerTablet} />
        </PortalDrawer>
      )}
      {isDrawerTablet1Open && (
        <PortalDrawer
          overlayColor="rgba(229, 219, 255, 0.7)"
          placement="Right"
          onOutsideClick={closeDrawerTablet1}
        >
          <DrawerTablet onClose={closeDrawerTablet1} />
        </PortalDrawer>
      )}
    </>
  );
};

export default MyAccount;
